var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5041 48H2.18185C1.43333 48 0.800781 47.5143 0.800781 46.9491V8.12868C0.800781 7.81022 1.01166 7.56343 1.22251 7.4042L11.8915 0.318426C12.1024 0.159195 12.4292 0.0795898 12.7454 0.0795898H47.4092C48.1577 0.0795898 48.8008 0.565249 48.8008 1.13052V47.0366C48.8008 47.5223 48.1577 48 47.5251 48H47.5041ZM3.45751 45.9858H46.1125V2.09388H13.262L3.44696 8.61437V45.9858H3.45751Z",
    fill: "url(#paint0_linear_403_181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8509 9.10001H2.18185C1.43333 9.10001 0.800781 8.61436 0.800781 8.04909C0.800781 7.48382 1.44387 7.00613 2.18185 7.00613H11.4593V1.04296C11.4593 0.477689 12.1024 0 12.8509 0C13.5994 0 14.2425 0.485651 14.2425 1.04296V8.12868C14.137 8.61434 13.494 9.09204 12.8509 9.09204V9.10001Z",
    fill: "url(#paint1_linear_403_181)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.785 26.2571H8.79201C8.04349 26.2571 7.40039 25.7714 7.40039 25.2061V13.1285C7.40039 12.5633 8.04349 12.0856 8.79201 12.0856H14.1265C14.875 12.0856 15.5181 12.5712 15.5181 13.1285C15.5181 13.6858 14.875 14.1795 14.1265 14.1795H10.0782V24.2428H23.4039V14.1795H19.3556C18.6071 14.1795 17.964 13.6938 17.964 13.1285C17.964 12.5633 18.6071 12.0856 19.3556 12.0856H24.6901C25.4386 12.0856 26.0817 12.5712 26.0817 13.1285V25.2061C26.1871 25.7714 25.544 26.2571 24.8061 26.2571H24.785Z",
    fill: "url(#paint2_linear_403_181)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4605 18.2H14.126C13.3775 18.2 12.7344 17.7144 12.7344 17.1571V13.1285C12.7344 12.5633 13.3775 12.0856 14.126 12.0856H19.4605C20.209 12.0856 20.8521 12.5712 20.8521 13.1285V17.1571C20.8521 17.7223 20.209 18.2 19.4605 18.2ZM15.5071 16.1857H18.1743V14.1715H15.5071V16.1857Z",
    fill: "url(#paint3_linear_403_181)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.785 43.3266H8.79201C8.04349 43.3266 7.40039 42.8409 7.40039 42.2757V30.1981C7.40039 29.6328 8.04349 29.1471 8.79201 29.1471H14.1265C14.875 29.1471 15.5181 29.6328 15.5181 30.1981C15.5181 30.7633 14.875 31.241 14.1265 31.241H10.0782V41.3123H23.4039V31.241H19.3556C18.6071 31.241 17.964 30.7554 17.964 30.1981C17.964 29.6407 18.6071 29.1471 19.3556 29.1471H24.6901C25.4386 29.1471 26.0817 29.6328 26.0817 30.1981V42.2757C26.1871 42.8409 25.544 43.3266 24.8061 43.3266H24.785Z",
    fill: "url(#paint4_linear_403_181)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4605 35.2775H14.126C13.3775 35.2775 12.7344 34.7918 12.7344 34.2266V30.1981C12.7344 29.6328 13.3775 29.1471 14.126 29.1471H19.4605C20.209 29.1471 20.8521 29.6328 20.8521 30.1981V34.2266C20.8521 34.7918 20.209 35.2775 19.4605 35.2775ZM15.5071 33.2632H18.1743V31.249H15.5071V33.2632Z",
    fill: "url(#paint5_linear_403_181)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 14.1715H32.7861C32.0376 14.1715 31.3945 13.6858 31.3945 13.1206C31.3945 12.5553 32.0376 12.0776 32.7861 12.0776H40.7879C41.5364 12.0776 42.169 12.5633 42.169 13.1206C42.169 13.6779 41.5259 14.1715 40.7879 14.1715Z",
    fill: "url(#paint6_linear_403_181)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 20.2143H32.7861C32.0376 20.2143 31.3945 19.7286 31.3945 19.1634C31.3945 18.5981 32.0376 18.1204 32.7861 18.1204H40.7879C41.5364 18.1204 42.169 18.6061 42.169 19.1634C42.169 19.7207 41.5259 20.2143 40.7879 20.2143Z",
    fill: "url(#paint7_linear_403_181)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 26.2571H32.7861C32.0376 26.2571 31.3945 25.7714 31.3945 25.2062C31.3945 24.6409 32.0376 24.1632 32.7861 24.1632H40.7879C41.5364 24.1632 42.169 24.6489 42.169 25.2062C42.169 25.7635 41.5259 26.2571 40.7879 26.2571Z",
    fill: "url(#paint8_linear_403_181)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 31.249H32.7861C32.0376 31.249 31.3945 30.7633 31.3945 30.206C31.3945 29.6487 32.0376 29.2426 32.7861 29.2426H40.7879C41.5364 29.2426 42.169 29.7283 42.169 30.2856C42.169 30.8429 41.5259 31.249 40.7879 31.249Z",
    fill: "url(#paint9_linear_403_181)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 37.2918H32.7861C32.0376 37.2918 31.3945 36.8061 31.3945 36.2488C31.3945 35.6915 32.0376 35.1979 32.7861 35.1979H40.7879C41.5364 35.1979 42.169 35.6835 42.169 36.2488C42.169 36.8141 41.5259 37.2918 40.7879 37.2918Z",
    fill: "url(#paint10_linear_403_181)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7879 43.3266H32.7861C32.0376 43.3266 31.3945 42.8409 31.3945 42.2757C31.3945 41.7104 32.0376 41.2247 32.7861 41.2247H40.7879C41.5364 41.2247 42.169 41.7104 42.169 42.2757C42.169 42.8409 41.5259 43.3266 40.7879 43.3266Z",
    fill: "url(#paint11_linear_403_181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_181",
    x1: 24.8008,
    y1: 0.0795898,
    x2: 24.8008,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_181",
    x1: 7.52162,
    y1: 0,
    x2: 7.52162,
    y2: 9.10001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_181",
    x1: 16.7467,
    y1: 12.0856,
    x2: 16.7467,
    y2: 26.2571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_181",
    x1: 16.7932,
    y1: 12.0856,
    x2: 16.7932,
    y2: 18.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_181",
    x1: 16.7467,
    y1: 29.1471,
    x2: 16.7467,
    y2: 43.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_181",
    x1: 16.7932,
    y1: 29.1471,
    x2: 16.7932,
    y2: 35.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_181",
    x1: 36.7818,
    y1: 12.0776,
    x2: 36.7818,
    y2: 14.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_181",
    x1: 36.7818,
    y1: 18.1204,
    x2: 36.7818,
    y2: 20.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_403_181",
    x1: 36.7818,
    y1: 24.1632,
    x2: 36.7818,
    y2: 26.2571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_403_181",
    x1: 36.7818,
    y1: 29.2426,
    x2: 36.7818,
    y2: 31.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_403_181",
    x1: 36.7818,
    y1: 35.1979,
    x2: 36.7818,
    y2: 37.2918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_403_181",
    x1: 36.7818,
    y1: 41.2247,
    x2: 36.7818,
    y2: 43.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon20.bc9a7461e914ac7e9c817c11946c8767.svg";
export { ForwardRef as ReactComponent };